﻿import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';

export default class TKShowMore extends TKCustomElementFactory {
    content?: HTMLElement;
    showingElements: number;
    openClassName: string;
    disableClassName: string;
    expandButton?: HTMLButtonElement;
    foldButton?: HTMLButtonElement;
    minHeight: number;

    constructor() {
        super();

        this.content = this.querySelector('[data-tk-content]') || undefined;
        this.showingElements = Number(this.getAttribute('data-tk-showing-elements')) || 1;
        this.openClassName = this.getAttribute('data-tk-open-class-name') || 'tk-show-more--open';
        this.disableClassName = this.getAttribute('data-tk-disable-class-name') || 'tk-show-more--disable';
        this.expandButton = this.querySelector('[data-tk-expand-button]') || undefined;
        this.foldButton = this.querySelector('[data-tk-fold-button]') || undefined;
        this.minHeight = this.getMinHeight();
    }

    connectedCallback(): void {
        if (!this.content || !this.expandButton || !this.foldButton) throw new Error('Show more: Button is missing!');
        if (this.content.scrollHeight === this.minHeight) {
            this.classList.add(this.disableClassName);
        } else {
            this.fold();
            this.registerClickListener();
        }
    }

    registerClickListener() {
        const onExpand = this.expand.bind(this);
        this.pushListener({ event: 'click', element: this.expandButton!, action: onExpand });
        const onFold = this.fold.bind(this);
        this.pushListener({ event: 'click', element: this.foldButton!, action: onFold });
        const onRecalc = this.recalc.bind(this);
        this.pushListener({ event: 'tk-show-more-recalc', element: this, action: onRecalc });
    }

    getMinHeight(): number {
        if (!this.content || this.content.childElementCount === 0) return 0;
        const rectContent = this.content.getBoundingClientRect();
        const childElement = this.content.children.item(this.showingElements - 1) as HTMLElement;
        if (!childElement) return 0;
        const childRect = childElement.getBoundingClientRect();
        const { marginBottom } = window.getComputedStyle(childElement);
        const { top } = rectContent;
        const { bottom } = childRect;
        return bottom - top + (parseInt(marginBottom, 10) || 0);
    }

    expand() {
        this.content!.style.maxHeight = '100%';
        this.classList.add(this.openClassName);
        this.removeListener(this.content!);
    }

    fold() {
        this.content!.style.maxHeight = `${this.minHeight}px`;
        this.classList.remove(this.openClassName);
        const onTransitionEnd = this.scrollToExpandButton.bind(this);
        this.pushListener({ event: 'transitionend', element: this.content!, action: onTransitionEnd });
    }

    scrollToExpandButton() {
        if (!this.expandButton) return;
        this.expandButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    recalc() {
        this.minHeight = this.getMinHeight();
        this.fold();
    }
}
